/**
 * De kostenstrook: welke iconen er op een kaart horen, in welke rijen.
 *
 * De volgorde is de gedrukte volgorde van de fysieke kaart — `cards-basic.json` draagt de
 * kosten per kaart in precies die volgorde, vastgepind door `kostenvolgorde.test.ts` in
 * contracts tegen de kaartexport van Thijs. Eén rij per grondstofsoort, het aantal naast
 * elkaar in die rij, zoals op de gedrukte kaart: Walter de Zanger toont bovenaan één
 * graan en daaronder twee wol naast elkaar.
 *
 * Dit is bewust een pure module: drie plekken tekenen dezelfde strook (de hand, de
 * stapelbrowser en de uitvergrote kaart), en de toets kan zonder pixi bewijzen dat er
 * nooit iets wordt afgekapt — de fout waardoor IJzeren Hein zijn wol verzweeg.
 */

export interface KostenRij {
  readonly soort: string;
  readonly aantal: number;
}

/** De rijen van de strook, in kaartvolgorde; soorten zonder aantal vallen weg. */
export function kostenRijen(
  kosten: Readonly<Record<string, number | undefined>> | undefined,
): KostenRij[] {
  return Object.entries(kosten ?? {})
    .filter((paar): paar is [string, number] => (paar[1] ?? 0) > 0)
    .map(([soort, aantal]) => ({ soort, aantal }));
}

/**
 * De maat van één icoon en de stap naar het volgende, op de kleine kaart (68 hoog).
 *
 * Vier rijen van 16 is 64 en past dus nét; de toets bewaakt dat geen kaart meer rijen of
 * bredere rijen nodig heeft dan de plaat aankan.
 */
export const KOSTEN_ICOON = { maat: 15, stap: 16 } as const;
